module.exports = __webpack_public_path__ + "img/ics_f_chat_warning.4e1633dd.svg";